import React from 'react';
import {
  ApButtonGroup,
  ApButtonMain,
  ApButtonSecondary,
} from '@alixpartners/ui-components';
import { StyledModal, TextContent } from './PublishedModal.styles';
import { getText } from './utils';
import { SpendTypeEnum } from '..';

interface IProps {
  isOpen: boolean;
  spendType: SpendTypeEnum;
  hasMoreClassification: boolean;
  onNavigate(): void;
  onClassifyMore(spendType: SpendTypeEnum): void;
  onClose(): void;
}

export const PublishedModal: React.FC<IProps> = ({
  isOpen,
  spendType,
  hasMoreClassification,
  onNavigate,
  onClassifyMore,
  onClose,
}) => {
  const text = getText(spendType, hasMoreClassification);

  const handleClassifyMore = () => {
    const moreType =
      spendType === SpendTypeEnum.THIRD_PARTY
        ? SpendTypeEnum.PERSONNEL
        : SpendTypeEnum.THIRD_PARTY;

    onClassifyMore(moreType);
  };

  return (
    <StyledModal
      isOpen={isOpen}
      header={text.header}
      isDismissible
      hasClosed={onClose}
      footer={() => {
        return (
          <ApButtonGroup justifyContent="flex-end">
            {hasMoreClassification && (
              <ApButtonSecondary onClick={onNavigate}>
                {text.navigateButton}
              </ApButtonSecondary>
            )}
            <ApButtonMain
              onClick={hasMoreClassification ? handleClassifyMore : onNavigate}
            >
              {hasMoreClassification
                ? text.classifyMoreButton
                : text.navigateButton}
            </ApButtonMain>
          </ApButtonGroup>
        );
      }}
    >
      <TextContent>{text.content}</TextContent>
    </StyledModal>
  );
};
